import React, { useEffect, useRef, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

/** Minimal cursor — an ink dot plus a softly lagging ring. */
const Cursor = () => {
  const [enabled, setEnabled] = useState(false);
  const [hover, setHover] = useState(false);

  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const ringX = useSpring(x, { stiffness: 220, damping: 26, mass: 0.7 });
  const ringY = useSpring(y, { stiffness: 220, damping: 26, mass: 0.7 });
  const raf = useRef(null);

  useEffect(() => {
    const mq = window.matchMedia("(hover: hover) and (pointer: fine)");
    if (!mq.matches) return;
    setEnabled(true);

    const onMove = (e) => {
      if (raf.current) cancelAnimationFrame(raf.current);
      raf.current = requestAnimationFrame(() => {
        x.set(e.clientX);
        y.set(e.clientY);
      });
    };
    const onOver = (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      const isInteractive = !!t.closest(
        'a, button, input, textarea, [role="button"], [data-cursor="hover"]'
      );
      setHover(isInteractive);
    };

    window.addEventListener("mousemove", onMove, { passive: true });
    window.addEventListener("mouseover", onOver, { passive: true });
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", onOver);
      if (raf.current) cancelAnimationFrame(raf.current);
    };
  }, [x, y]);

  if (!enabled) return null;

  return (
    <>
      <motion.div
        className={`cursor-ring ${hover ? "is-hover" : ""}`}
        style={{ x: ringX, y: ringY }}
        aria-hidden="true"
      />
      <motion.div
        className={`cursor-dot ${hover ? "is-hover" : ""}`}
        style={{ x, y }}
        aria-hidden="true"
      />
    </>
  );
};

export default Cursor;
